import React from 'react';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { QueryListResponse, SelectOption } from 'global';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { bpfAPI, BPFAPINameSpase, StagesConstructor } from 'modules/stages';

import { accountSelectors } from '../../redux/accountReducer';

export const Template = () => {
  const { id } = useParams<{ id: string }>();

  const accountId = useSelector(accountSelectors.accountId);

  const { data, loading, error } = useQuery(bpfAPI.fetchTemplateById, {
    skip: !id,
    variables: { id },
  });

  const { data: departmentsResponse, loading: isDepartmentsLoading } = useQuery<
    BPFAPINameSpase<QueryListResponse<SelectOption>>
  >(bpfAPI.department.fetchDepartmentsOptions);

  return (
    <PageContainer title="BPF Template" error={error} loading={loading}>
      <StagesConstructor
        accountId={accountId}
        template={data?.bpf?.template ?? null}
        isDepartmentsLoading={isDepartmentsLoading}
        departmentsOptions={departmentsResponse?.bpf?.result?.list ?? []}
      />
    </PageContainer>
  );
};
